<template>
  <d-button-group class="buttons">
    <d-button size="sm" class="btn-info" @click.prevent="edit()">
      <i class="fas fa-pencil-alt mr-1"></i>
      <span class="d-none d-lg-inline">Editar</span>
    </d-button>
    <d-button size="sm" class="btn-danger" @click.prevent="confirmDeleteRow()">
      <i class="fas fa-trash mr-1"></i>
      <span class="d-none d-lg-inline">Deletar</span>
    </d-button>
  </d-button-group>
</template>

<script>
import { mapActions } from 'vuex';
import Events from '_utils/events';
import { _DELETE_DISTRIBUTOR_ } from '_modules/distributor/components/DistributorModel';

export default {
  name: 'distributor-buttons',
  props: {
    distributor: {
      type: Object,
      default: null,
    },
  },
  components: {},
  computed: {},
  methods: {
    ...mapActions(['setToggle']),
    edit() {
      this.$router.push(`/admin/distribuidores/${this.distributor.id}`);
    },
    confirmDeleteRow() {
      this.setToggle({ type: 'confirm_modal', bool: true });
      Events.$emit(_DELETE_DISTRIBUTOR_, this.distributor);
    },
  },
  mounted() {},
};
</script>
